import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import {NotificationHandler} from './notification.handler';
import {AuthService} from '../service/auth.service';
import {UrlHelper} from './url.helper';
import * as Sentry from '@sentry/angular';
import {environment} from '../../environments/environment';
import smartlookClient from 'smartlook-client';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService,
              private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // @ts-ignore
    return next.handle(request)
      .pipe(catchError(err => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (err.status !== 403) {
          NotificationHandler.handleError(err);
        } else {
          console.error(err);
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (err.status === 401 || err.status === 403) {
          // auto logout if 401 response returned from api
          this.authService.logout()
            .then(() => {
              Sentry.configureScope(scope => scope.setUser(null));
              if (environment.smartlook.enabled) smartlookClient.anonymize();
            })
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            .finally(async () => {
              await this.router.navigate([UrlHelper.SIGN_IN_PATH], {replaceUrl: true});
            });
        }
        return throwError(err);
      }));
  }

  public static getStatusCode(error: unknown): number | undefined {
    return error instanceof HttpErrorResponse
      ? error.error instanceof ErrorEvent
        ? undefined
        : error.status
      : undefined;
  }
}
